import {withExplorer} from "../../layout/Explorer";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "../../store";
import {selectData, setData} from "../../reducer/iam/newLecturerReducer";
import {makeStyles} from "@material-ui/core/styles";
import {Step, StepLabel, Stepper, Typography} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";
import {HomeImage} from "../Home";
import Box from "../../lib/appfuse-react/component/Box";
import clsx from "clsx";
import lang from "../../lib/appfuse-react/core/lang";
import newLecturerService from "../../service/iam/newLecturerService";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import utilService from "../../service/util/utilService";
import valueChange from "../../component/Judge/ValueChange";
import {useHistory} from "react-router-dom";
import Paper from "../../lib/appfuse-react/component/Paper";
import code from "../../lib/appfuse-react/core/code";
import {
    BasicData,
    EducationAndWorkExperience,
    EvaluationAndTeachingExperience, MobileBasicData,
    ReleaseOfPersonalInformationAgreement,
    TrainingExperience
} from "../../component/Lecturer";
import Button from "../../lib/appfuse-react/component/Button";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";
import TextField from "../../lib/appfuse-react/component/TextField";
import SelectField from "../../lib/appfuse-react/component/SelectField";

const useStyles = makeStyles(theme => ({
    form: {
        width: '78%',
        height: '100%',
        overflow: 'auto',
        paddingTop:  theme.spacing(2),
        paddingBottom:  theme.spacing(2),
        paddingLeft:  theme.spacing(3),
        paddingRight:  theme.spacing(3),
        margin: 4
    },
    stepper: {
        width: '22%',
        height: '100%',
        overflow: 'auto',
        margin: 4
    },
    transparent: {
        opacity: 0.95,
        filter: 'drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.7))',
    },
}));

const STEPS = ['Basic Info', 'Lecturer - Education And Work Experience', 'Lecturer - Training', 'Lecturer - Review Registration'];
const stepsForNotTAf = ['Basic Info', 'Lecturer - Education And Work Experience', 'Lecturer - Training', 'Lecturer - Review Registration', 'Release of Personal Information Agreement'];

const validateData = [
    ['chineseName', 'englishName', 'gender', 'photo', 'idNo', 'birthYear', 'tafColleague', 'serviceOrganization', 'serviceDepartment', 'jobTitle',
        'serviceOrganizationAddress', 'permanentAddress', 'mailingAddress', 'departure', 'email', 'contactTel', 'mobilePhone'],
    ['educations', 'workExperiences'],
    ['trainings'],
    ['qualification', 'evaluationExperiences', 'teachingExperiences']
]

function NewLecturer() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const prompt = usePrompt();
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState(STEPS);
    const data = useSelector(selectData);
    const county = useSelector(selectCounty);

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    useEffect(() => {
        (async () => {
            await code.assert('lecturerQualification');

            dispatch(setData({tafColleague:false, educations:[], workExperiences:[]}));

            if(lang.isEmpty(county)) {
                const county = await utilService.findCounty();
                dispatch(setCounty(county));
            }
        })();
    }, []);

    const getValidateData = () => {
        const name = validateData[activeStep];
        const result = {};
        name.forEach(key => { result[key] = valueChange.getValue(data[key], null); });
        return result;
    };

    const handleNext = async () => {
        try {
            await newLecturerService.validate(getValidateData());
            if(activeStep===0) {
                if(data?.tafColleague) setSteps(STEPS);
                else setSteps(stepsForNotTAf);
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } catch (e) {
            const dictionary = {company:'Service Organization'};
            prompt.alert(e, {title:'Invalid input.', dictionary});
        }
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleChange = (event) => dispatch(setData(event.value));
    const handleComplete = async () => {
        try {
            if(steps.length===5 && !data.agreement) {
                throw new Error( i18n.translate('Please check the agreement.'));
            }
            await newLecturerService.complete(data);
            prompt.confirm('You Have Successfully Registered New Lecturer.', {
                title: 'Welcome to Flora Web',
                onAction: () => {
                    dispatch(setData({}));
                    history.push('/');
                }
            });
        } catch (e) {
            const dictionary = {company:'Service Organization'};
            prompt.alert(e, {title:'Failed to registered new lecturer.', dictionary});
        }
    };

    const handleDevChange = (event) => {
        const value = event.value;
        setActiveStep(value);
    }

    const DevOptions = [
        {value: 0, label: i18n.translate("Basic Info")},
        {value: 1, label: i18n.translate("Lecturer - Education And Work Experience")},
        {value: 2, label: i18n.translate("Lecturer - Training")},
        {value: 3, label: i18n.translate("Lecturer - Review Registration")},
    ]

    return (
        <Paper fullWidth fullHeight position='relative'>
            <Box position="absolute" top={0} left={0} fullWidth fullHeight backgroundColor="black" backgroundOpacity={0.9} >
                <HomeImage />
            </Box>
            { !isMobile ?
                <Box width='90%' height='98%' display='flex' justifyContent='center' position='absolute' top='0.5%'
                  left='5%'>
                <Paper className={clsx(classes.form, classes.transparent)}>
                    <ApplicationContent value={data} activeStep={activeStep} steps={steps} onChange={handleChange}
                                        onNext={handleNext} onBack={handleBack} onComplete={handleComplete}/>
                </Paper>
                <Paper className={clsx(classes.stepper, classes.transparent)}>
                    <ApplicationStepper activeStep={activeStep} steps={steps}/>
                </Paper>
            </Box> : <Box fullWidth fullHeight>
                <Paper className={classes.transparent} fullWidth fullHeight overflow={'auto'}>
                    {/*<Box>*/}
                    {/*    <SelectField label='開發用' value={activeStep} options={DevOptions} valueAccessor={'value'} textAccessor={'label'} onChange={handleDevChange} fullWidth/>*/}
                    {/*</Box>*/}
                    <Box padding={2}>
                        <ApplicationContent value={data} activeStep={activeStep} steps={steps} onChange={handleChange}
                                            onNext={handleNext} onBack={handleBack} onComplete={handleComplete}/>
                    </Box>
                </Paper>
            </Box>}
        </Paper>
    );
}

function Frame(props) {
    const {title, children, fullHeight} = props;

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    return (
        <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden'>
            <Box marginBottom={1}>
                <Typography variant="h5">{i18n.translate(title)}</Typography>
            </Box>
            <Box fullWidth fullHeight={fullHeight} overflow={isMobile?'hidden':'auto'} paddingTop={1}>
                {children}
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text={props.onBack? "Back":"Close"} color="secondary" onClick={props.onBack || props.onClose} />
                <Button text={props.onNext? "Next":"Complete"} variant="contained" color="primary" onClick={props.onNext || props.onComplete} />
            </Box>
        </Box>
    );
}

function ApplicationContent(props) {
    const {value={}, activeStep, steps=[]} = props;

    const router = useRouter();

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    const CombinedBasicData = isMobile? MobileBasicData: BasicData;

    if (activeStep === 0) {
        return (
            <Frame title='Basic Info' onClose={() => router.home()} onNext={props.onNext} fullHeight>
                <CombinedBasicData value={value} onChange={props.onChange} isNew newLecturer/>
            </Frame>
        );
    } else if (activeStep === 1) {
        return (
            <Frame title='Lecturer - Education And Work Experience' onBack={props.onBack} onNext={props.onNext}>
                <EducationAndWorkExperience value={value} onChange={props.onChange}/>
            </Frame>
        );
    } else if (activeStep === 2) {
        return (
            <Frame title='Lecturer - Training' onBack={props.onBack} onNext={props.onNext}>
                <TrainingExperience value={value} onChange={props.onChange}/>
            </Frame>
        );
    } else if (activeStep === 3) {
        if(steps.length===4) return (
            <Frame title='Lecturer - Review Registration' onBack={props.onBack} onComplete={props.onComplete}>
                <EvaluationAndTeachingExperience value={value} onChange={props.onChange}/>
            </Frame>
        );
        else if(steps.length===5) return (
            <Frame title='Lecturer - Review Registration' onBack={props.onBack} onNext={props.onNext}>
                <EvaluationAndTeachingExperience value={value} onChange={props.onChange}/>
            </Frame>
        );
        else return null;
    } else if (steps.length===5 && activeStep === 4) {
        return (
            <Frame title='Release of Personal Information Agreement' onBack={props.onBack} onComplete={props.onComplete}>
                <ReleaseOfPersonalInformationAgreement value={value} onChange={props.onChange}/>
            </Frame>
        );
    }
}

function ApplicationStepper(props) {
    const {activeStep, steps=[]} = props;

    return (
        <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label) => (
                <Step key={label}>
                    <StepLabel><Typography>{i18n.translate(label)}</Typography></StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}

export default withExplorer(NewLecturer);